import { IntegrationAnalysisQuery } from './analysis-query.js'

export const resolvers = [IntegrationAnalysisQuery]
